export default __webpack_public_path__ + "static/8-orders-list-ca97598e7b487fb29fbab97c5db95167.png";